import React from 'react';
import PropTypes from 'prop-types';
import {
  Card,
  Thumbnail,
  StyledCardInfoList,
  CardContent,
  StyledCTA,
} from './styles';
import { CardInfo, CardLink, InfoIcon } from '../event-list-card/styles';
import iconSrc from '../../utils/iconSrc';
import { VisuallyHidden } from '../styled/accessibility';

const EventCard = ({
  name,
  location,
  date,
  thumbnailImage,
  text,
  ctaText,
  ctaLink,
}) => (
  <Card>
    <Thumbnail
      mobileW={600}
      mobileH={350}
      desktopW={600}
      desktopH={350}
      focusArea="center"
      fit="fill"
      image={thumbnailImage}
      description={name}
    />
    <CardContent>
      <CardLink link={ctaLink} tabIndex="-1">
        <VisuallyHidden>{name}</VisuallyHidden>
      </CardLink>
      <h3>{name}</h3>
      <p>{text}</p>
      <StyledCardInfoList>
        {location && (
          <CardInfo>
            <InfoIcon src={iconSrc('map-marker')} />
            {location}
          </CardInfo>
        )}
        <CardInfo>
          <InfoIcon src={iconSrc('calendar')} />
          {date}
        </CardInfo>
      </StyledCardInfoList>
    </CardContent>
    <StyledCTA bg="primary" link={ctaLink}>
      <VisuallyHidden>{name}</VisuallyHidden> {ctaText}
    </StyledCTA>
  </Card>
);

EventCard.propTypes = {
  name: PropTypes.string.isRequired,
  location: PropTypes.string,
  date: PropTypes.string.isRequired,
  thumbnailImage: PropTypes.object.isRequired,
  text: PropTypes.string.isRequired,
  ctaText: PropTypes.string.isRequired,
  ctaLink: PropTypes.oneOfType([PropTypes.array, PropTypes.object]).isRequired,
};

export default EventCard;
